var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreener = function SvgScreener(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    width: "1em",
    height: "1em",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.st0{stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,21H9v-1h9V21z M20,17H7v-1h13V17z M22,13H5v-1h17V13z M24,9H3V8h21V9z M26,5H1V4h25V5z"
  })));
};
export { SvgScreener as ReactComponent };